// import React, { useState } from "react";
// import { usePackageDetails } from "../hooks/usePackageDetails";
// import styles from "./PackageDetails1.module.css";


// const PackageDetails1 = ({ packageId, mode, onNavigate }) => {
//   const [activeTab, setActiveTab] = useState("itinerary");
//   const { data: pkg, isLoading, isError } = usePackageDetails(packageId, mode);

//   if (isLoading) return <div className={styles.loader}>Loading Package Details...</div>;
//   if (isError || !pkg) return <div className={styles.error}>Package not found.</div>;

//   // 👇 THE FIX: Smart Destructuring
//   // This checks if the data has a nested .package property (Live) 
//   // or if the data itself is the package (Demo)
//   const p = pkg.package ? pkg.package : pkg;

//   // Safely get arrays with fallbacks to empty arrays
//   const itineraries = pkg.itineraries || [];
//   const hotelBookings = pkg.hotelBookings || [];
//   const flightBookings = pkg.flightBookings || [];
//   const includes = pkg.includes || [];
//   const excludes = pkg.excludes || [];
//   const terms = pkg.termsandConditions || [];

//   return (
//     <div className={styles.container}>
//       {mode === "builder" && (
//         <button 
//           className={styles.backBtn} 
//           onClick={() => onNavigate({ name: "home", params: null })}
//         >
//           &larr; Back to Home Editor
//         </button>
//       )}

//       {/* Top Section: Hero Info */}
//       <div className={styles.layoutGrid}>
//         <div className={styles.imageSection}>
//           {/* 👇 Using the 'p' variable we defined above */}
//           <img src={p?.imageSrc} alt={p?.packageName} className={styles.mainImage} />
//         </div>

//         <div className={styles.infoSection}>
//           <span className={styles.badge}>{p?.travelType || "Travel"}</span>
//           <h1 className={styles.title}>{p?.packageName}</h1>
//           <p className={styles.destination}>📍 {p?.destination || p?.destinationsCover}</p>
//           <p className={styles.duration}>🕒 {p?.duration}</p>
          
//           <div className={styles.pricing}>
//              <span className={styles.currency}>{p?.currency}</span>
//              <span className={styles.price}>{p?.price?.toLocaleString()}</span>
//           </div>
          
//           <div className={styles.actionBox}>
//             <button className={styles.bookBtn}>Enquire Now</button>
//             {p?.contactName && (
//                 <p className={styles.contactHint}>Contact: {p.contactName}</p>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Details Section with Tabs */}
//       <div className={styles.detailsBody}>
//         <div className={styles.tabHeader}>
//            {['itinerary', 'hotels-flights', 'inclusions', 'policies'].map((tab) => (
//              <button 
//                 key={tab}
//                 className={activeTab === tab ? styles.activeTab : styles.tab} 
//                 onClick={() => setActiveTab(tab)}
//              >
//                {tab.replace('-', ' & ').toUpperCase()}
//              </button>
//            ))}
//         </div>

//         <div className={styles.tabContent}>
           
//            {/* TAB 1: ITINERARY */}
//            {activeTab === 'itinerary' && (
//              <div className={styles.itineraryList}>
//                 <h3>Daily Itinerary</h3>
//                 {itineraries.length > 0 ? itineraries.map((item, index) => (
//                   <div key={index} className={styles.itineraryItem}>
//                     <div className={styles.dayBadge}>Day {index + 1}</div>
//                     <div className={styles.itineraryText}>
//                       <h4>{item.title}</h4>
//                       <p className={styles.location}>📍 {item.location}</p>
//                       <p>{item.description}</p>
//                       {item.meals && <span className={styles.mealBadge}>🍴 Meals: {item.meals}</span>}
//                     </div>
//                   </div>
//                 )) : <p>No itinerary details provided.</p>}
//              </div>
//            )}

//            {/* TAB 2: HOTELS & FLIGHTS */}
//            {activeTab === 'hotels-flights' && (
//              <div className={styles.accommodationSection}>
//                 <div className={styles.subSection}>
//                     <h3>🏨 Hotel Stays</h3>
//                     {hotelBookings.length > 0 ? hotelBookings.map((hotel, index) => (
//                         <div key={index} className={styles.detailCard}>
//                             <strong>{hotel.hotelName}</strong>
//                             <p>{hotel.city} | {hotel.roomType} | {hotel.nights} Nights</p>
//                         </div>
//                     )) : <p>No hotel information available.</p>}
//                 </div>
//                 <div className={styles.subSection}>
//                     <h3>✈️ Flight Details</h3>
//                     {flightBookings.length > 0 ? flightBookings.map((flight, index) => (
//                         <div key={index} className={styles.detailCard}>
//                             <strong>{flight.airline} ({flight.flightNumber})</strong>
//                             <p>{flight.departureCity} ➔ {flight.arrivalCity}</p>
//                             <small>{new Date(flight.departureDateTime).toLocaleString()}</small>
//                         </div>
//                     )) : <p>No flight information available.</p>}
//                 </div>
//              </div>
//            )}

//            {/* TAB 3: INCLUSIONS */}
//            {activeTab === 'inclusions' && (
//              <div className={styles.inclusionGrid}>
//                 <div className={styles.incColumn}>
//                     <h3 className={styles.incTitle}>✅ What's Included</h3>
//                     {includes.length > 0 ? (
//                         <ul>{includes.map((inc, i) => <li key={i}>{inc.description}</li>)}</ul>
//                     ) : <p>{p?.includes || "Please contact us for inclusions."}</p>}
//                 </div>
//                 <div className={styles.excColumn}>
//                     <h3 className={styles.excTitle}>❌ What's Excluded</h3>
//                     <ul>
//                         {excludes.length > 0 ? excludes.map((exc, i) => <li key={i}>{exc.description}</li>) : <li>Personal expenses</li>}
//                     </ul>
//                 </div>
//              </div>
//            )}

//            {/* TAB 4: POLICIES */}
//            {activeTab === 'policies' && (
//              <div className={styles.policySection}>
//                 <h3>Terms & Conditions</h3>
//                 {terms.length > 0 ? terms.map((policy, i) => (
//                     <div key={i} className={styles.policyItem}>
//                         <strong>{policy.title}</strong>
//                         <p>{policy.description}</p>
//                     </div>
//                 )) : <p>Standard terms and conditions apply.</p>}
//              </div>
//            )}
//         </div>
//       </div>
//     </div>
//   );
// };


// export default PackageDetails1;

import React, { useState } from "react";
import { usePackageDetails } from "../hooks/usePackageDetails";
import styles from "./PackageDetails1.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const PackageDetails1 = ({ packageId, mode, onNavigate }) => {
  const [activeTab, setActiveTab] = useState("itinerary");
  const { data: pkg, isLoading, isError } = usePackageDetails(packageId, mode);

  if (isLoading) return <div className={styles.loader}>Loading Package Details...</div>;
  if (isError || !pkg) return <div className={styles.error}>Package not found.</div>;

  const p = pkg.package ? pkg.package : pkg;

  const itineraries = pkg.itineraries || [];
  const hotelBookings = pkg.hotelBookings || [];
  const flightBookings = pkg.flightBookings || [];
  const includes = pkg.includes || [];
  const excludes = pkg.excludes || [];
  const terms = pkg.termsandConditions || [];

  // ✅ Fallback Image Logic
  const fallbackImage =
    fallbackImages[Number(packageId?.toString()?.slice(-1)) % fallbackImages.length];

  const imageUrl =
    p?.imageSrc && p.imageSrc.trim() !== ""
      ? p.imageSrc
      : fallbackImage;

  return (
    <div className={styles.container}>
      {mode === "builder" && (
        <button
          className={styles.backBtn}
          onClick={() => onNavigate({ name: "home", params: null })}
        >
          &larr; Back to Home Editor
        </button>
      )}

      {/* Top Section */}
      <div className={styles.layoutGrid}>
        <div className={styles.imageSection}>
          <img
            src={imageUrl}
            alt={p?.packageName}
            className={styles.mainImage}
            onError={(e) => {
              e.target.src = fallbackImage;
            }}
          />
        </div>

        <div className={styles.infoSection}>
          <span className={styles.badge}>{p?.travelType || "Travel"}</span>
          <h1 className={styles.title}>{p?.packageName}</h1>
          <p className={styles.destination}>📍 {p?.destination || p?.destinationsCover}</p>
          <p className={styles.duration}>🕒 {p?.duration}</p>

          <div className={styles.pricing}>
            <span className={styles.currency}>{p?.currency}</span>
            <span className={styles.price}>{p?.price?.toLocaleString()}</span>
          </div>

          <div className={styles.actionBox}>
            <button className={styles.bookBtn}>Enquire Now</button>
            {p?.contactName && (
              <p className={styles.contactHint}>Contact: {p.contactName}</p>
            )}
          </div>
        </div>
      </div>

      {/* Rest of your component remains EXACTLY the same */}
      {/* Tabs Section */}
      <div className={styles.detailsBody}>
        <div className={styles.tabHeader}>
          {["itinerary", "hotels-flights", "inclusions", "policies"].map((tab) => (
            <button
              key={tab}
              className={activeTab === tab ? styles.activeTab : styles.tab}
              onClick={() => setActiveTab(tab)}
            >
              {tab.replace("-", " & ").toUpperCase()}
            </button>
          ))}
        </div>

        <div className={styles.tabContent}>
          
          {/* TAB 1 */}
          {activeTab === "itinerary" && (
            <div className={styles.itineraryList}>
              <h3>Daily Itinerary</h3>
              {itineraries.length > 0 ? itineraries.map((item, index) => (
                <div key={index} className={styles.itineraryItem}>
                  <div className={styles.dayBadge}>Day {index + 1}</div>
                  <div className={styles.itineraryText}>
                    <h4>{item.title}</h4>
                    <p className={styles.location}>📍 {item.location}</p>
                    <p>{item.description}</p>
                    {item.meals && <span className={styles.mealBadge}>🍴 Meals: {item.meals}</span>}
                  </div>
                </div>
              )) : <p>No itinerary details provided.</p>}
            </div>
          )}

          {/* TAB 2 */}
          {activeTab === "hotels-flights" && (
            <div className={styles.accommodationSection}>
              <div className={styles.subSection}>
                <h3>🏨 Hotel Stays</h3>
                {hotelBookings.length > 0 ? hotelBookings.map((hotel, index) => (
                  <div key={index} className={styles.detailCard}>
                    <strong>{hotel.hotelName}</strong>
                    <p>{hotel.city} | {hotel.roomType} | {hotel.nights} Nights</p>
                  </div>
                )) : <p>No hotel information available.</p>}
              </div>

              <div className={styles.subSection}>
                <h3>✈️ Flight Details</h3>
                {flightBookings.length > 0 ? flightBookings.map((flight, index) => (
                  <div key={index} className={styles.detailCard}>
                    <strong>{flight.airline} ({flight.flightNumber})</strong>
                    <p>{flight.departureCity} ➔ {flight.arrivalCity}</p>
                    <small>{new Date(flight.departureDateTime).toLocaleString()}</small>
                  </div>
                )) : <p>No flight information available.</p>}
              </div>
            </div>
          )}

          {/* TAB 3 */}
          {activeTab === "inclusions" && (
            <div className={styles.inclusionGrid}>
              <div className={styles.incColumn}>
                <h3 className={styles.incTitle}>✅ What's Included</h3>
                {includes.length > 0 ? (
                  <ul>{includes.map((inc, i) => <li key={i}>{inc.description}</li>)}</ul>
                ) : <p>{p?.includes || "Please contact us for inclusions."}</p>}
              </div>

              <div className={styles.excColumn}>
                <h3 className={styles.excTitle}>❌ What's Excluded</h3>
                <ul>
                  {excludes.length > 0 ? excludes.map((exc, i) => <li key={i}>{exc.description}</li>) : <li>Personal expenses</li>}
                </ul>
              </div>
            </div>
          )}

          {/* TAB 4 */}
          {activeTab === "policies" && (
            <div className={styles.policySection}>
              <h3>Terms & Conditions</h3>
              {terms.length > 0 ? terms.map((policy, i) => (
                <div key={i} className={styles.policyItem}>
                  <strong>{policy.title}</strong>
                  <p>{policy.description}</p>
                </div>
              )) : <p>Standard terms and conditions apply.</p>}
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default PackageDetails1;